import React from "react";
import "./HomeBrandSection.css";

function HomeBrandSection() {
  const brands = [
    "/images/brand1.avif",
    "/images/brand2.webp",
    "/images/brand3.webp",
    "/images/brand4.avif",
    "/images/brand5.avif",
    "/images/brand6.avif",
    "/images/brand1.avif",
    "/images/brand4.avif",
  ];

  return (
    <section className="brand-section">
      <div className="container">
        <div className="brand-marquee">
          <div className="brand-marquee-track">
            {[...brands, ...brands].map((brand, index) => (
              <div className="brand-logo" key={index}>
                <img 
                  src={brand} 
                  alt={`Brand ${index + 1}`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeBrandSection;